module.exports = __webpack_public_path__ + "img/share.293ee961.png";